import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumDocumentGenerationOutputFileType implements BaseEnumType {
  private static allValues: EnumDocumentGenerationOutputFileType[] = []; // make sure this is top-most
  
  public static docx = new EnumDocumentGenerationOutputFileType(0, "Docx", "enum_document_generation_output_file_type_docx");
  public static csv = new EnumDocumentGenerationOutputFileType(1, "Csv", "enum_document_generation_output_file_type_csv");
  public static utf8 = new EnumDocumentGenerationOutputFileType(2, "Utf8", "enum_document_generation_output_file_type_utf8");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDocumentGenerationOutputFileType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isDocx() { return this === EnumDocumentGenerationOutputFileType.docx; }
  public isCsv() { return this === EnumDocumentGenerationOutputFileType.csv; }
  public isUtf8() { return this === EnumDocumentGenerationOutputFileType.utf8; }

  public static getValues(): readonly EnumDocumentGenerationOutputFileType[] {
    return EnumDocumentGenerationOutputFileType.allValues;
  }

  public static getValuesExcept0(): readonly EnumDocumentGenerationOutputFileType[] {
    return EnumDocumentGenerationOutputFileType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDocumentGenerationOutputFileType {
    const found = EnumDocumentGenerationOutputFileType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDocumentGenerationOutputFileType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDocumentGenerationOutputFileType): EnumDocumentGenerationOutputFileType {
    const found = name ? EnumDocumentGenerationOutputFileType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDocumentGenerationOutputFileType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumDocumentGenerationOutputFileType>): boolean {
    return this.key === other?.key;
  }
}